export default {
  terms: {
    title: "Terms and conditions",
  },
  privacy: {
    title: "Privacy notice",
  },
}
